export default __webpack_public_path__ + "static/mindfulness_icon-88efe65fbd9da78f27d613afae9b9a29.svg";